import React from 'react';

import { ShareLinkConfigForm } from '../../form/link-config.form';
import { ShareThumbnail } from '../../form/fields/thumbnail';
import ShareLinkNameInput from '../../form/fields/link-title';
import { useSharePanelStore } from 'src/common/store/share.store';

export const ShareLinkFormPanel = () => {
  const sharedJourney = useSharePanelStore((state) => state.sharedJourney)!;
  const isNeueActive = sharedJourney?.data?.neue;

  return (
    <div className='flex flex-col'>
      <ShareLinkNameInput isNeueActive={isNeueActive} />
      <ShareThumbnail isNeueActive={isNeueActive} />
      <ShareLinkConfigForm isNeueActive={isNeueActive} />
    </div>
  );
};
